import React from "react";
import CreateForm from "./create-form";

const createpost = () => {
  return (
    <div className="pt-40">
      <CreateForm />
    </div>
  );
};

export default createpost;
